import { createStore } from "redux";
import { Reducers } from "../reducers";
import { loadState, saveState } from "./persist";

export const Store = createStore(
  Reducers,
  loadState(),
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

// As respostas só chegam ao backend no envio final (Conclusao), e
// /api/getrespostas não repõe nada; sem isto um reload perde tudo.
Store.subscribe(() => {
  const { respostas, idiomas } = Store.getState();
  saveState({ respostas, idiomas });
});
